import { c as _c } from "react/compiler-runtime";
import { MembersEmptyPage } from "@components/common/empty-page/members-empty-page";
import { BulkSuccessDialog } from "@components/common/faro-table/bulk-dialog/bulk-success-dialog";
import { EntitiesToolbar } from "@components/common/toolbar/entities-toolbar";
import { useRemoveMemberBulkDialogContent } from "@components/table/members/bulk-actions/bulk-remove-member-helper";
import { DEFAULT_TEAM_MEMBERS_SORT_BY } from "@components/table/members/members-sort-constants";
import { TeamMembersTable } from "@components/table/members/team-members-table";
import { mapTeamMembersToSdbMembers } from "@components/table/teams/teams-table-utils";
import { isTeamMembersSortField } from "@custom-types/type-guards";
import { useMediaQueryList } from "@hooks/use-media-query";
import { useSubjectsSortByQuery } from "@hooks/use-subjects-sort-by-query";
import { InviteMemberToTeam } from "@pages/members/teams/invite-member-to-team";
import { TeamDetailsInfoBar } from "@pages/members/teams/team-details/team-details-info-bar";
import { useTeamMembersPageBulkActions } from "@pages/members/teams/use-team-members-page-bulk-actions";
import { NotFoundPage } from "@pages/not-found-page";
import { useCompanyId } from "@context-providers/company-id-provider";
import { TEAM_DISPLAY_NAME } from "@src/constants/team-constants";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { resetTableState } from "@store/table/table-slice";
import { bulkActionNameSelector, shouldShowSuccessDialogSelector } from "@store/table/table-selector";
import { fetchingTeamsFlagsSelector, nextTeamMemberSelector, selectedTeamMembersSelector, selectedTeamTotalCountSelector, teamWithRoleByIdSelector } from "@store/teams/teams-selector";
import { fetchTeamMembers } from "@store/teams/teams-slice-thunk";
import { useTeamMembersSearchQuery } from "@hooks/teams/use-team-members-search-query";
import { useCallback, useEffect, useMemo } from "react";
import { TeamMembersMobileView } from "@pages/members/teams/team-members-mobile-view";
import { getExportComponent, getMembersMapById } from "@utils/member-utils";
import { ColumnPreferencesProvider } from "@context-providers/table/column-preferences-provider";
import { TEAM_MEMBERS_TABLE_COLUMNS } from "@components/table/members/members-table-constants";
import { MembersSort } from "@components/table/members/members-sort";
/**
 * Contains the Members tab of the team details
 */
export function TeamMembers(t0) {
  const $ = _c(86);
  const {
    team,
    companyMembers
  } = t0;
  const dispatch = useAppDispatch();
  const companyId = useCompanyId();
  const t1 = team?.id;
  let t2;
  if ($[0] !== t1) {
    t2 = teamWithRoleByIdSelector(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const teamDetails = useAppSelector(t2);
  const teamMembers = useAppSelector(selectedTeamMembersSelector);
  const teamMembersTotalCount = useAppSelector(selectedTeamTotalCountSelector);
  const {
    isFetchingTeamMembers,
    isFetchingMoreMembers
  } = useAppSelector(fetchingTeamsFlagsSelector);
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  let t3;
  if ($[2] !== companyMembers) {
    t3 = getMembersMapById(companyMembers);
    $[2] = companyMembers;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const membersMap = t3;
  const {
    isDebouncingSearch,
    search
  } = useTeamMembersSearchQuery();
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      defaultSort: DEFAULT_TEAM_MEMBERS_SORT_BY,
      isValidSort: isTeamMembersSortField
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const {
    sortBy,
    setSortBy
  } = useSubjectsSortByQuery(t4);
  const nextTeamMember = useAppSelector(nextTeamMemberSelector);
  const {
    successDialogContent
  } = useRemoveMemberBulkDialogContent("team");
  const shouldShowEmptyPage = isFetchingTeamMembers === "succeeded" && teamMembers.length === 0;
  const bulkActionName = useAppSelector(bulkActionNameSelector);
  const shouldShowSuccessDialog = useAppSelector(shouldShowSuccessDialogSelector);
  const isLoading = isFetchingTeamMembers === "pending" || isFetchingMoreMembers || isDebouncingSearch;
  let t5;
  let t6;
  if ($[5] !== dispatch) {
    t5 = () => () => {
      dispatch(resetTableState());
    };
    t6 = [dispatch];
    $[5] = dispatch;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[8] !== companyId || $[9] !== dispatch || $[10] !== search || $[11] !== sortBy || $[12] !== team) {
    t7 = () => {
      if (team) {
        dispatch(fetchTeamMembers({
          companyId,
          teamId: team.id,
          start: undefined,
          sortBy,
          search
        }));
      }
    };
    t8 = [companyId, dispatch, team, sortBy, search];
    $[8] = companyId;
    $[9] = dispatch;
    $[10] = search;
    $[11] = sortBy;
    $[12] = team;
    $[13] = t7;
    $[14] = t8;
  } else {
    t7 = $[13];
    t8 = $[14];
  }
  useEffect(t7, t8);
  let t9;
  bb0: {
    if (!teamMembers.length || !teamDetails) {
      let t10;
      if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = [];
        $[15] = t10;
      } else {
        t10 = $[15];
      }
      t9 = t10;
      break bb0;
    }
    let t10;
    if ($[16] !== membersMap || $[17] !== teamDetails.role || $[18] !== teamMembers) {
      t10 = mapTeamMembersToSdbMembers(teamMembers, teamDetails.role, membersMap);
      $[16] = membersMap;
      $[17] = teamDetails.role;
      $[18] = teamMembers;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    t9 = t10;
  }
  const sbdTeamMembers = t9;
  let t10;
  if ($[20] !== companyId || $[21] !== dispatch || $[22] !== nextTeamMember || $[23] !== search || $[24] !== sortBy || $[25] !== team) {
    t10 = async () => {
      if (team?.id && nextTeamMember) {
        await dispatch(fetchTeamMembers({
          companyId,
          teamId: team.id,
          start: nextTeamMember,
          sortBy,
          search
        }));
      }
    };
    $[20] = companyId;
    $[21] = dispatch;
    $[22] = nextTeamMember;
    $[23] = search;
    $[24] = sortBy;
    $[25] = team;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const loadMoreMembers = t10;
  let t11;
  if ($[27] !== companyId || $[28] !== sbdTeamMembers || $[29] !== team) {
    t11 = {
      companyId,
      team,
      teamMembers: sbdTeamMembers
    };
    $[27] = companyId;
    $[28] = sbdTeamMembers;
    $[29] = team;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  const buttonComponents = useTeamMembersPageBulkActions(t11);
  if (!team) {
    let t12;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <NotFoundPage />;
      $[31] = t12;
    } else {
      t12 = $[31];
    }
    return t12;
  }
  let t12;
  if ($[32] !== bulkActionName || $[33] !== shouldShowSuccessDialog || $[34] !== successDialogContent) {
    t12 = bulkActionName === "removeMember" && shouldShowSuccessDialog && <BulkSuccessDialog dialogContent={successDialogContent} />;
    $[32] = bulkActionName;
    $[33] = shouldShowSuccessDialog;
    $[34] = successDialogContent;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== isLoading) {
    t13 = <TeamDetailsInfoBar isLoading={isLoading} />;
    $[36] = isLoading;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== shouldShowEmptyPage || $[39] !== team) {
    t14 = !shouldShowEmptyPage && !team.category.isManaged && <InviteMemberToTeam team={team} buttonVariant="filled" />;
    $[38] = shouldShowEmptyPage;
    $[39] = team;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== sbdTeamMembers.length || $[42] !== setSortBy || $[43] !== sortBy) {
    t15 = sbdTeamMembers.length > 0 && <MembersSort sortBy={sortBy} setSortBy={setSortBy} tableSubject="team" />;
    $[41] = sbdTeamMembers.length;
    $[42] = setSortBy;
    $[43] = sortBy;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  let t16;
  if ($[45] !== buttonComponents.export || $[46] !== sbdTeamMembers.length) {
    t16 = getExportComponent(sbdTeamMembers.length, buttonComponents.export);
    $[45] = buttonComponents.export;
    $[46] = sbdTeamMembers.length;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  let t17;
  if ($[48] !== isLoading || $[49] !== t14 || $[50] !== t15 || $[51] !== t16 || $[52] !== teamMembersTotalCount) {
    t17 = <EntitiesToolbar toolbarEntityName="Member" numberOfRows={teamMembersTotalCount} mobileAction={t14} isLoading={isLoading} sortActions={t15} exportComponent={t16} />;
    $[48] = isLoading;
    $[49] = t14;
    $[50] = t15;
    $[51] = t16;
    $[52] = teamMembersTotalCount;
    $[53] = t17;
  } else {
    t17 = $[53];
  }
  let t18;
  if ($[54] !== shouldShowEmptyPage || $[55] !== team) {
    t18 = team && shouldShowEmptyPage && <MembersEmptyPage subtitle={`All the members of your ${TEAM_DISPLAY_NAME} will be found here. You can add members to your ${TEAM_DISPLAY_NAME} by inviting them.`} button={<InviteMemberToTeam team={team} buttonVariant="filled" shouldUseAutoWidth={true} />} />;
    $[54] = shouldShowEmptyPage;
    $[55] = team;
    $[56] = t18;
  } else {
    t18 = $[56];
  }
  let t19;
  if ($[57] !== buttonComponents || $[58] !== isLoading || $[59] !== isScreenSmOrSmaller || $[60] !== loadMoreMembers || $[61] !== sbdTeamMembers || $[62] !== shouldShowEmptyPage || $[63] !== sortBy || $[64] !== team) {
    t19 = isScreenSmOrSmaller && !shouldShowEmptyPage && <TeamMembersMobileView bulkActionButtons={buttonComponents} members={sbdTeamMembers} isLoading={isLoading} team={team} sortBy={sortBy} loadMoreItems={loadMoreMembers} />;
    $[57] = buttonComponents;
    $[58] = isLoading;
    $[59] = isScreenSmOrSmaller;
    $[60] = loadMoreMembers;
    $[61] = sbdTeamMembers;
    $[62] = shouldShowEmptyPage;
    $[63] = sortBy;
    $[64] = team;
    $[65] = t19;
  } else {
    t19 = $[65];
  }
  let t20;
  if ($[66] !== buttonComponents || $[67] !== companyId || $[68] !== isLoading || $[69] !== isScreenSmOrSmaller || $[70] !== loadMoreMembers || $[71] !== nextTeamMember || $[72] !== sbdTeamMembers || $[73] !== setSortBy || $[74] !== shouldShowEmptyPage || $[75] !== sortBy || $[76] !== team || $[77] !== teamMembersTotalCount) {
    t20 = !isScreenSmOrSmaller && !shouldShowEmptyPage && <ColumnPreferencesProvider tableKey="team-members-table" columns={TEAM_MEMBERS_TABLE_COLUMNS} options={{
      nonConfigurableColumns: ["options"],
      defaultVisibleColumns: ["user", "email", "status", "joinedDate"]
    }}><TeamMembersTable companyId={companyId} members={sbdTeamMembers} team={team} isLoading={isLoading} bulkActionButtons={buttonComponents} loadMoreItems={loadMoreMembers} hasMoreItems={!!nextTeamMember} sortBy={sortBy} setSortBy={setSortBy} teamMembersTotalCount={teamMembersTotalCount} /></ColumnPreferencesProvider>;
    $[66] = buttonComponents;
    $[67] = companyId;
    $[68] = isLoading;
    $[69] = isScreenSmOrSmaller;
    $[70] = loadMoreMembers;
    $[71] = nextTeamMember;
    $[72] = sbdTeamMembers;
    $[73] = setSortBy;
    $[74] = shouldShowEmptyPage;
    $[75] = sortBy;
    $[76] = team;
    $[77] = teamMembersTotalCount;
    $[78] = t20;
  } else {
    t20 = $[78];
  }
  let t21;
  if ($[79] !== t12 || $[80] !== t13 || $[81] !== t17 || $[82] !== t18 || $[83] !== t19 || $[84] !== t20) {
    t21 = <>{t12}{t13}{t17}{t18}{t19}{t20}</>;
    $[79] = t12;
    $[80] = t13;
    $[81] = t17;
    $[82] = t18;
    $[83] = t19;
    $[84] = t20;
    $[85] = t21;
  } else {
    t21 = $[85];
  }
  return t21;
}